module.exports = __webpack_public_path__ + "static/media/img02.15c554e0.svg";